import { useCallback, useEffect, useState, useRef } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';

interface Response {
  cityName: string | undefined;
  cityError: boolean;
  getCity: () => Promise<string | undefined>;
}

export const useFetchCity = (postalCode: string | undefined): Response => {
  const [cityName, setCityName] = useState<string | undefined>();
  const [cityError, setCityError] = useState<boolean>(false);
  const debounceTimerRef = useRef<number | undefined>(undefined);

  const getCity = useCallback(async () => {
    if (postalCode?.length === 4) {
      try {
        const res = await apiClient.get<{ city: string }>(ApiType.apimMembershipApi, {
          url: ApiPaths[ApiType.apimMembershipApi].address.cityName,
          params: { postalCode },
        });
        setCityName(res?.data?.city);
        setCityError(false);
        return res?.data?.city;
      } catch (e) {
        setCityError(true);
        setCityName('UKJENT');
        return 'UKJENT';
      }
    }
    return 'UKJENT';
  }, [postalCode]);

  useEffect(() => {
    // Clear existing timer
    if (debounceTimerRef.current) {
      window.clearTimeout(debounceTimerRef.current);
    }

    // Only fetch if we have a complete 4-digit postal code
    if (postalCode?.length === 4) {
      debounceTimerRef.current = window.setTimeout(() => {
        getCity();
      }, 300);
    } else {
      // Clear city name if postal code is incomplete
      setCityName(undefined);
      setCityError(false);
    }

    return () => {
      if (debounceTimerRef.current) {
        window.clearTimeout(debounceTimerRef.current);
      }
    };
  }, [postalCode, getCity]);

  return { cityName, cityError, getCity };
};
